import React, { useContext } from "react";

import "./style.scss";

// material ui icons
import PublishIcon from "@material-ui/icons/Publish";

// To use history
import { useHistory } from "react-router-dom";

// global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";
const FileUploadButton = () => {
  const state = useContext(StateContext);

  const setState = useContext(StateDispatchContext);

  const history = useHistory();

  const goToComingSoonPage = () => {
    history.push("/console/Schema/new-schema/file-upload/coming-soon-feature");
    setState({
      ...state,
      schema: { ...state.schema, isComingSoonPageDisplayed: true },
    });
  };

  return (
    <div
      onClick={goToComingSoonPage}
      className={
        state.theme === "dark"
          ? "__decisionBoxDark __decisionBox"
          : "__decisionBoxLight __decisionBox"
      }
      id="schemaFileUploadEmptyState"
    >
      <h3
        className={
          state.theme === "dark"
            ? "__decisionBoxHeaderDark"
            : "__decisionBoxHeaderLight"
        }
      >
        Upload json or ylm file
      </h3>
      <PublishIcon
        style={{
          fontSize: "50",
          color: state.theme === "dark" ? "#e2e9ff" : "#122742",
        }}
      />
    </div>
  );
};

export default FileUploadButton;
